import { useState, useEffect } from 'react';
import parse from 'html-react-parser'
import { Tooltip } from 'react-tooltip'
import Scenepohja_01 from './scenes/01/Scenepohja_01.js'
import Scenepohja_02 from './scenes/02/scenepohja_02.js'
import Scenepohja_03 from './scenes/03/scenepohja_03.js'
import EndDemo from './endDemo'

import GeneralGameInfoModal from './scenes/GeneralGameInfoModal'
import ClientInfoModal from './scenes/ClientInfoModal'
import { data } from './data/data_start.js'
import { ProsenttiDonitsi } from './additionalComponents/prosenttidonitsi'
import { OsaamistasoDonitsi } from './additionalComponents/osaamistasodonitsi'
import soundsOffIcon from './images/soundsOffIcon.png'
import soundsOnIcon from './images/soundsOnIcon.png'
import lom2 from './images/lom2.pdf'
import ProgressBar from 'react-bootstrap/ProgressBar';
import StartView from './startView'
import { validoi } from './utils/validoi'
import { getImageSource } from './utils/utils'
import Scenepohja_medication from './scenes/medication/Scenepohja_medication.js';
import Scenepohja_apv from './scenes/apvscenes/Scenepohja_apv.js';
import { f1, f3, f5, facePalm, infokuva } from './images'
// import { f1, f3, f5, facePalm, infokuva, siiri_disappointed, siiri_neutral, siiri_wtf, siiri_peukku } from './images'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

function MainView() {


    const [visibleEndDemo, setVisibleEndDemo] = useState(false)
    const [visible_scenepohja_01, setVisible_scenepohja_01] = useState(false)
    const [visible_scenepohja_02, setVisible_scenepohja_02] = useState(false)
    const [visible_scenepohja_03, setVisible_scenepohja_03] = useState(false)
    const [visible_scenepohja_medication, setVisible_scenepohja_medication] = useState(false)
    const [visible_scenepohja_apv, setVisible_scenepohja_apv] = useState(false)


    const [visibleStartButton, setVisibleStartButton] = useState(true)
    const [visibleStartView, setVisibleStartView] = useState(true)

    const [visibleNameForm, setVisibleNameForm] = useState(false)

    const [visibleEnimi, setVisibleEnimi] = useState(false)

    const [enimi, setEnimi] = useState('')
    const [enimiValid, setEnimiValid] = useState(false)
    const [nimiError, setNimiError] = useState('')
    const [nimiOk, setNimiOk] = useState(false)//onko nimi syötetty vai ei

    const [gameStarted, setGameStarted] = useState(false)

    const [ohjNimi, setOhjNimi] = useState('Teija')


    const [points, setPoints] = useState(0)
    const [maxPoints, setMaxPoints] = useState(0)
    const [gradeAvg, setGradeAvg] = useState(0)

    // const [faceImg, setFaceImg] = useState(f3)
    const [faceImg, setFaceImg] = useState(f3)

    const [kokonaisSceneLkm, setKokonaisSceneLkm] = useState(10)// hardcoded 
    const [pelatutScenetLkm, setPelatutScenetLkm] = useState(0)
    const [progress, setProgress] = useState(0)

    const [scenePalautteet, setScenePalautteet] = useState([])

    const [soundsOn, setSoundsOn] = useState(false)

    const [visibleGeneralGameInfoModal, setVisibleGeneralGameInfoModal] = useState(false);
    const [visibleClientInfoModal, setVisibleClientInfoModal] = useState(false);

    const handleShowGeneralGameInfoModal = () => setVisibleGeneralGameInfoModal(true);
    const handleCloseGeneralGameInfoModal = () => setVisibleGeneralGameInfoModal(false);

    const handleShowClientInfoModal = () => setVisibleClientInfoModal(true);
    const handleCloseClientInfoModal = () => setVisibleClientInfoModal(false);

    // ******************
    const [visibleFeedbackModal, setVisibleFeedbackModal] = useState(false);
    const handleShowFeedbackModal = () => setVisibleFeedbackModal(true);
    const handleCloseFeedbackModal = () => setVisibleFeedbackModal(false);



    // ******************
    function resetEverything() {
        // Jos tulee game over ja käsky pelata uudelleen, ajetaan tämä
        setGameStarted(false)
        setNimiOk(false)
        setNimiError('')
        setEnimiValid(false)
        setEnimi('')
        setPoints(0)
        setGradeAvg(0)
        setFaceImg(f3)
        setPelatutScenetLkm(0)
        setScenePalautteet([])
        setProgress(0)

        hideAllScenepohjat()
        setVisibleStartView(true)

    }

    const [aloitaNappiPainettu, setAloitaNappiPainettu] = useState(false)
    const klikattuAloitaNappia = () => {
        setVisibleNameForm(true)
        setAloitaNappiPainettu(true)
        // setGameStarted(true)
        // setVisibleStartView(false)

    }

    const start = () => {
        visible_scenepohja_01 ? setVisible_scenepohja_01(false) : setVisible_scenepohja_01(true)
        setVisibleStartButton(false)
        setVisibleStartView(false)
        setNimiOk(true)
        setGameStarted(true)
    }


    const toggleStartView = () => {
        visibleStartView ? setVisibleStartView(false) : setVisibleStartView(true)
    }

    // äänet päällä/pois-event handler
    const toggleSound = () => {
        soundsOn ? setSoundsOn(false) : setSoundsOn(true)
    }

    let soundMsg
    if (soundsOn) {
        soundMsg = "äänet päällä"
    }
    else {
        soundMsg = "äänet pois"
    }

    const handleSubmit = (event) => {
        event.preventDefault()

        let msg = validoi(enimi)
        if (msg == 'ok') {
            setEnimiValid(true)
            setNimiOk(true)
            setVisibleStartView(false)
            // setVisibleStartButton(true)
            setVisible_scenepohja_01(true)
        }
        else {
            setEnimiValid(false)
            setNimiError(msg)
        }

        setVisibleEnimi(true)




    }

    const nimiChanged = (event) => {
        setEnimi(event.target.value)
    }


    const hideAllScenepohjat = () => {

        setVisible_scenepohja_01(false)
        setVisible_scenepohja_02(false)
        setVisible_scenepohja_03(false)

    }

    const visibilityHandler_main = (valinta) => {

        hideAllScenepohjat()

        switch (valinta) {

            case "startView":

                // infosivu näkyviin
                setVisibleStartView(true)
                // setVisible_scenepohja_01(false)
                // setVisible_scenepohja_02(false)
                break;
            case "01":
                setVisible_scenepohja_01(true)
                // setVisible_scenepohja_02(false)
                break;

            case "02":
                // setVisible_scenepohja_01(false)
                setVisible_scenepohja_02(true)
                break;

            case "insuliini":
                // setVisible_scenepohja_01(false)
                // setVisible_scenepohja_02(false)
                setVisible_scenepohja_medication(true)
                break;

            case "pisto tehty":
                // setVisible_scenepohja_01(false)
                // setVisible_scenepohja_02(false)
                setVisibleEndDemo(true)
                break;
            case "jatka sceneen 03":
                setVisible_scenepohja_03(true)

                break;


            case "play again":
                resetEverything()
                break;

        }

    }


    const scoreHandler_main = (optio, scene, sceneMaxp) => {

        let currentPoints = points + optio.pisteet
        setPoints(currentPoints)
        let currentMaxPoints = maxPoints + sceneMaxp
        setMaxPoints(currentMaxPoints)
        let pointsPerMaxPoints = currentPoints / currentMaxPoints//"osaamistaso" eg 3p / 5p

        setProgress(((pelatutScenetLkm + 1) / kokonaisSceneLkm) * 100)//0-100%
        setPelatutScenetLkm(pelatutScenetLkm + 1)


        //NB 3.2 muutetaan siten, että Teijan naamakuva kuvastaa vain edellistä valintaa, ei kokonaisosaamista
        if (optio.pisteet == sceneMaxp) {
            setFaceImg(f5)
            // setFaceImg(siiri_peukku)
        }
        else if (optio.pisteet == 0) {
            // setFaceImg(siiri_wtf)
            setFaceImg(facePalm)
        }
        else
            setFaceImg(f3)
        // setFaceImg(siiri_neutral)




        setGradeAvg(pointsPerMaxPoints) // pisteet per max pisteet


        setScenePalautteet([...scenePalautteet, { scene: scene, palaute: optio.koontiteksti, pisteet: optio.pisteet, harjoiteltava: optio.harjoiteltava, arviointitiedosto: optio.arviointitiedosto }])


    }



    return (
        <div id='MainContainer'>


            <div id='upper' >


                {visibleStartView ? <div id='startViewContainer'>

                    <div id="image" className='kuvaBox' style={{ paddingTop: '2em', backgroundColor: 'white' }}>
                        <img src={infokuva} />
                    </div>

                    <div id="text">
                        <div>
                            {!gameStarted ? !visibleStartButton ? null : <div id='sth'>{parse(data.info_uusi)}</div> : null}

                            <div>
                                {(!nimiOk) ? <div>
                                    {/* <h4>{data.namePrompt}</h4> */}
                                    {enimiValid ? <h5>nimi ok</h5> : <h5>{nimiError}</h5>}

                                    <Form>
                                        <Form.Group className="mb-3" controlId="etunimi">
                                            <Form.Label>{parse(data.namePrompt)}</Form.Label>
                                            <Form.Control type="text" placeholder="etunimi tähän"
                                                onChange={(e) => nimiChanged(e)} />

                                        </Form.Group>

                                        <Button variant="primary" type="submit" onClick={(e) => handleSubmit(e)}>
                                            Aloita
                                        </Button>
                                    </Form>

                                </div> : null}
                            </div>




                        </div>

                    </div>


                </div> : null}

                {/* <div> */}




                {
                    visible_scenepohja_01 ? <Scenepohja_01 scoreHandler_main={scoreHandler_main} visibilityHandler_main={visibilityHandler_main} soundsOn={soundsOn} enimi={enimi} ohjNimi={ohjNimi} /> : null
                }

                {
                    visible_scenepohja_02 ? <Scenepohja_02 scoreHandler_main={scoreHandler_main} visibilityHandler_main={visibilityHandler_main} soundsOn={soundsOn} enimi={enimi} ohjNimi={ohjNimi} /> : null
                }

                {
                    visible_scenepohja_03 ? <Scenepohja_03 scoreHandler_main={scoreHandler_main} visibilityHandler_main={visibilityHandler_main} soundsOn={soundsOn} /> : null
                }
                {/* {
                    visible_scenepohja_medication ? <Scenepohja_medication scoreHandler_main={scoreHandler_main} visibilityHandler_main={visibilityHandler_main} soundsOn={soundsOn} enimi={enimi} ohjNimi={ohjNimi} /> : null

                } */}
                {/* {
                    visible_scenepohja_apv ? <Scenepohja_apv scoreHandler_main={scoreHandler_main} visibilityHandler_main={visibilityHandler_main} soundsOn={soundsOn} enimi={enimi} ohjNimi={ohjNimi} /> : null

                } */}



                {
                    visibleEndDemo ? <EndDemo /> : null

                }


                {/* </div> */}

            </div>




            <div id='lower'>
                <div id='status'>

                    <div>
                        <h4>{visibleEnimi ? data.nameLabel + enimi : null}</h4>
                    </div>
                    {/* <span> pelatut scenet: {pelatutScenetLkm}, points: {points}, osaaminen: {gradeAvg * 100}%</span> */}
                    <span> points: {points}, osaaminen: {gradeAvg * 100}%</span>

                    <div id='donutArea'>

                        <ProgressBar id='bar' now={progress} label={`${progress}%`} data-tooltip-content="tämä palkki näyttää pelin etenemisen 0-100%" />

                        <Tooltip anchorId="bar" />

                    </div>

                </div>

                <div id='actions_and_settings'>

                    <div>

                        <div>
                            <img id='faceImg' src={faceImg} className='small_image' data-tooltip-content='Klikkaa nähdäksesi Teijan palaute edellisestä valinnastasi' onClick={handleShowFeedbackModal} />

                            <Tooltip anchorId="faceImg" />
                        </div>
                    </div>

                    <div>
                        {!nimiOk ? <Button onClick={handleShowGeneralGameInfoModal}  >ohjeet</Button> : null}
                        <br />
                        <br />
                        {nimiOk ? <Button onClick={handleShowClientInfoModal}  >tietoja Pentistä</Button> : null}
                    </div>
                    <div>
                        {soundsOn ? <img src={soundsOnIcon} alt='sounds on' onClick={() => toggleSound()} /> : <img src={soundsOffIcon} alt='sounds off' onClick={() => toggleSound()} />}
                    </div>


                    <Modal
                        // size="lg"
                        // fullscreen={true}
                        // dialogClassName="modal-90w"
                        // className='testi'
                        dialogClassName="modal_"

                        show={visibleFeedbackModal}
                        onHide={handleCloseFeedbackModal}
                        backdrop="dynamic"
                        keyboard={true}
                    >
                        <Modal.Body style={{ height: '60vh' }}>


                            {scenePalautteet.length > 0 ?


                                <div style={{ height: '100%', width: '100%' }}>
                                    <embed style={{ height: '100%', width: '100%' }}

                                        // src={lom2 + "#toolbar=0"}

                                        src={getImageSource(scenePalautteet[scenePalautteet.length - 1].arviointitiedosto) + "#toolbar=0"}
                                        alt={'wtf'}

                                        type="application/pdf"
                                    />
                                </div> : null}


                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseFeedbackModal}>
                                jatka
                            </Button>

                        </Modal.Footer>
                    </Modal>


                    <Modal
                        show={visibleGeneralGameInfoModal}
                        onHide={handleCloseGeneralGameInfoModal}
                        backdrop="dynamic"
                        keyboard={true}
                    >
                        <Modal.Body>
                            <GeneralGameInfoModal />
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseGeneralGameInfoModal}>
                                jatka
                            </Button>

                        </Modal.Footer>
                    </Modal>

                    <Modal
                        show={visibleClientInfoModal}
                        onHide={handleCloseClientInfoModal}
                        backdrop="dynamic"
                        keyboard={true}
                    >
                        <Modal.Body>
                            <ClientInfoModal />
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseClientInfoModal}>
                                jatka
                            </Button>

                        </Modal.Footer>
                    </Modal>
                </div>

            </div>






        </div>



    );


}

export default MainView;
